export { default as lint } from './lint';
export { default as lintFix } from './fix';
export type { LintResult, LintOptions } from './types';
